import { Text } from '@televet/kibble-ui';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { TaskList } from 'pages/Tasks/types';
import React from 'react';
import { TaskStatus } from 'shared/types/graphql';
import { TaskGroupListCard } from './TaskGroupListCard';

type TaskGroupListProps = {
  taskLists: TaskList[];
  taskStatuses: TaskStatus[];
  completedTasksOnly?: boolean;
};

export const TaskGroupList = ({ taskLists, taskStatuses, completedTasksOnly }: TaskGroupListProps): JSX.Element => {
  return (
    <Flex direction="column" gap={4}>
      {completedTasksOnly && (
        <Text fontStyle="italic" fontSize="sm" textAlign="center">
          Custom tasks remain visible after completion. Other tasks are removed after 48 hours.
        </Text>
      )}
      {taskLists.map((taskList) => (
        <TaskGroupListCard
          key={taskList.id + completedTasksOnly ? 'completed' : 'needsReview'}
          taskList={taskList}
          taskStatuses={taskStatuses}
          completedTasksOnly={completedTasksOnly}
        />
      ))}
    </Flex>
  );
};
